export function normalizePublicLiveCount(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? Math.floor(value)
    : 0
}

export function parsePublicLiveCountEvent(raw: string): number | null {
  try {
    const envelope = JSON.parse(raw) as unknown
    if (!isRecord(envelope) || envelope.event !== 'live.count_changed') return null
    const data = envelope.data
    if (!isRecord(data) || typeof data.count !== 'number' || !Number.isFinite(data.count) || data.count < 0) {
      return null
    }
    return Math.floor(data.count)
  } catch {
    return null
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
